import React, { useContext, useCallback, useEffect, useState } from "react";
import "./DocumentUploadItem.css";
import { FileUpload } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import { ProgressSpinner } from "primereact/progressspinner";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { SidebarContext } from "../../CreateNewClaimModal/CreateNewClaimModal";

const DocumentUploadList = ({
  doc,
  uploadedDocs,
  docsBeingUploaded,
  handleDocuments
}) => {
  const {
    ownerSignedTitleImage,
    setOwnerSignedTitleImage,
    odometerInTitleImage,
    setOdometerInTitleImage,
    signedLRInTitleImage,
    setSignedLRInTitleImage
  } = useContext(SidebarContext);
  const [flash, setFlash] = React.useState(false);
  const [showTitleImageCheckboxes, setShowTitleImageCheckboxes] = useState(
    false
  );

  const getClassName = useCallback(
    (label, isLink) => {
      const statusString = uploadedDocs.find(d => d?.label === label)
        ? "DocUploadButton__done"
        : "DocUploadButton";
      const linkString = isLink ? "WithLink" : "";
      return `${statusString}${linkString}`;
    },
    [uploadedDocs]
  );

  // Trigger flash animation when the component mounts
  useEffect(() => {
    setFlash(true);
    const timer = setTimeout(() => setFlash(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  // Show the title image checkboxes if the document is a title image and has been uploaded
  useEffect(() => {
    if (
      doc?.label === "Title Image (Signed)" &&
      uploadedDocs.find(d => d?.label === doc?.label)
    ) {
      setShowTitleImageCheckboxes(true);
    } else {
      setShowTitleImageCheckboxes(false);
    }
  }, [doc, uploadedDocs]);

  return (
    <div className={`${flash ? "flash" : ""}`}>
      <div
        key={doc.value}
        className="target"
        data-pr-tooltip={doc.text}
        data-pr-position="left"
        data-pr-at="left center"
        data-pr-my="right center"
      >
        <div className="Upload">
          <FileUpload
            className={getClassName(doc?.label, doc?.link)}
            chooseLabel={doc?.label}
            auto
            accept={[
              "image/jpg",
              "image/jpeg",
              "image/png",
              "image/tiff",
              "application/pdf"
            ]}
            customUpload
            uploadHandler={handleDocuments(doc?.label)}
            mode={"basic"}
            chooseOptions={{
              icon:
                docsBeingUploaded?.length > 0 &&
                docsBeingUploaded.includes(doc?.label) ? (
                  <ProgressSpinner
                    style={{ width: "1em", height: "1em" }}
                    fill={"var(--surface-ground)"}
                    strokeWidth={4}
                  />
                ) : uploadedDocs.map(d => d.label).includes(doc?.label) ? (
                  "pi pi-check"
                ) : (
                  "pi pi-plus"
                )
            }}
            disabled={docsBeingUploaded?.length > 0}
            maxFileSize={52428800} // 50MB
          />
        </div>
        {doc.link && (
          <a
            href={doc.link}
            target={"_blank"}
            rel={"noreferrer"}
            style={{ textDecoration: "none" }}
          >
            <Button className="Download">
              <i className="pi pi-download"></i>
            </Button>
          </a>
        )}

        {docsBeingUploaded?.length > 0 &&
          docsBeingUploaded.includes(doc?.label) && (
            <ProgressBar
              className={"FileUploadProgress"}
              mode={"indeterminate"}
            ></ProgressBar>
          )}

        <Tooltip target={".target"} />
      </div>
      {showTitleImageCheckboxes && (
        <div className={"CheckboxMods"}>
          <div>
            <Checkbox
              checked={ownerSignedTitleImage}
              onChange={e => {
                setOwnerSignedTitleImage(e.checked);
              }}
              disabled={!uploadedDocs.find(d => d?.label === doc?.label)}
            />
            <label className="CheckboxModsLabel" htmlFor={`ownerSigned`}>
              Owner Signed Personally
            </label>
          </div>
          <div className={"OdometerInformationIncluded"}>
            <Checkbox
              checked={odometerInTitleImage}
              onChange={e => {
                setOdometerInTitleImage(e.checked);
              }}
              disabled={!uploadedDocs.find(d => d?.label === doc?.label)}
            />
            <label className="CheckboxModsLabel" htmlFor={`ownerSigned`}>
              Odometer Information Included
            </label>
          </div>
          <div className={"SignedLRIncluded"}>
            <Checkbox
              checked={signedLRInTitleImage}
              onChange={e => {
                setSignedLRInTitleImage(e.checked);
              }}
              disabled={!uploadedDocs.find(d => d?.label === doc?.label)}
            />
            <label className="CheckboxModsLabel" htmlFor={`ownerSigned`}>
              No Lien, or signed Lien Release Included
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentUploadList;
